<template>
    <div class="drawer drawer-end">
        <input id="note-sidebar" type="checkbox" class="drawer-toggle" />
        <div class="drawer-side z-[999]">
            <label class="drawer-overlay"></label>
            <div class="h-screen w-96 bg-base-200 flex flex-col">
                <div class="flex justify-between items-center p-4">
                    <h6 class="text-lg">{{ title }}</h6>
                    <label class="btn btn-ghost btn-circle btn-sm" for="note-sidebar" @click="$emit('close')">X</label>
                </div>
                <div class="flex flex-col flex-1 justify-center items-center" v-if="!notes.length">
                    <Progressbar v-if="directLoading" />
                    <NetworkError v-else-if="errors" @tryAgain="getData" />
                    <div class="flex flex-col justify-center items-center" v-else v-if="meta.current_page">
                        <ChatBubbleLeftEllipsisIcon class="w-16 h-16" />
                        <p class="mt-4 text-lg">{{ __('No notes found to display.') }}</p>
                    </div>
                </div>
                <div class="flex-1 overflow-y-auto scrollbar-small px-3 lg:px-4" id="chat-container" ref="chatContainer"
                    v-else>
                    <div class="flex flex-col" v-for="note in notes">
                        <div class="chat chat-start">
                            <div class="chat-image avatar">
                                <div class="w-10 rounded-full">
                                    <img :alt="note.user.name" :src="note.user.avatar" />
                                </div>
                            </div>
                            <div class="chat-header">
                                <span>{{ note.user.name }}</span>
                                <span class="px-1.5 inline-block opacity-80">|</span>
                                <time class="text-xs opacity-60">{{ note.time }}</time>
                            </div>
                            <div class="chat-bubble">{{ note.content }}</div>
                            <div class="chat-footer">
                                <span class="opacity-60">{{ note.created_at }}</span>
                                <!-- <span class="px-1.5 inline-block opacity-80">|</span>
                                <button class="curser-pointer text-red-500 hover:text-red-700 font-semibold">{{ __('Delete') }}</button> -->
                            </div>
                        </div>
                    </div>
                </div>
                <Form @submit="onSubmit" v-slot="{ errors }" class="shrink-0 border-t border-base-300 p-3">
                    <div class="flex items-end gap-2">
                        <Field as="textarea" name="content" v-model="note.content"
                            :class="{ 'textarea-error': errors.content }" rules="required"
                            class="textarea min-h-12 max-h-48 flex-1 resize-none overflow-y-auto p-2"
                            :placeholder="__('Type a message...')" />
                        <button type="submit" class="btn btn-primary btn-sm flex-shrink-0" :disabled="loadingBtn">
                            <span class="loading loading-spinner" v-if="loadingBtn"></span>
                            {{ __('Send') }}
                        </button>

                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script setup>

import { Field, Form } from "vee-validate";
import { computed, nextTick, onMounted } from 'vue';
import { ChatBubbleLeftEllipsisIcon, TrashIcon } from "@heroicons/vue/24/outline";
const { notes, note, directLoading, loadingBtn, meta, errors, getNotes, storeNote } = useDashboard();
const props = defineProps(['type', 'id', 'title']);
defineEmits(['close']);
const chatContainer = ref(null)

const scrollToBottom = async () => {
    await nextTick()
    if (chatContainer.value) {
        chatContainer.value.scrollTop = chatContainer.value.scrollHeight
    }
}
watch(notes, () => {
    scrollToBottom()
}, { deep: true })
const getData = () => {
    setTimeout(() => getNotes(props.type, props.id), 100)
}
const onSubmit = () => {
    Object.assign(note, { id: props.id, type: props.type });
    storeNote()
}
onMounted(() => {
    getData();
});
</script>